module.exports = __webpack_public_path__ + "img/cns_printer_mac28.0b248925.png";